import {ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit, PLATFORM_ID, Renderer2} from '@angular/core'
import {PipesModule} from '../../../../pipes/pipes.module'
import {DOCUMENT, isPlatformBrowser, NgTemplateOutlet} from '@angular/common'
import {DocumentService} from '../../../../../craft/utils/document.service'
import {TranslocoService} from '@ngneat/transloco'

@Component({
  selector: 'bgo-iframe-otovo',
  standalone: true,
  templateUrl: './otovo.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PipesModule, NgTemplateOutlet],
  styles: `
    :host {
      display: block;
    }
  `,
})
export class OtovoComponent implements OnInit, OnDestroy {
  private script: unknown
  constructor(
    private readonly renderer2: Renderer2,
    @Inject(DOCUMENT) private readonly document,
    private readonly documentService: DocumentService,
    @Inject(PLATFORM_ID) private readonly platformId: Record<string, unknown>,
    private readonly translocoService: TranslocoService,
  ) {}
  ngOnInit() {
    // Make sure the otovo script which handles the iframe is only loaded once even if the iframe is multiple times on the page.
    if (
      !this.documentService.getElementByAttribute('src', 'https://solar.otovo.com/js/search.js') &&
      isPlatformBrowser(this.platformId)
    ) {
      const s = this.renderer2.createElement('script')
      s.type = 'text/javascript'
      s.src = 'https://solar.otovo.com/js/search.js'
      this.renderer2.appendChild(this.document.body, s)
      this.script = s
    }
  }
  ngOnDestroy() {
    // Remove the script from the dom if we destroy the component.
    if (isPlatformBrowser(this.platformId) && this.script instanceof HTMLScriptElement) {
      this.script.remove()
    }
  }

  get lang(): string {
    return this.translocoService.getActiveLang()
  }
}
